<script lang="ts" setup>
    import { type RouteLocationRaw } from 'vue-router';
    import { type TextMessage } from '../../TextMessagesTypes';

    const props = defineProps<{
        textMessage: TextMessage;
        href?: string;
        to?: RouteLocationRaw;
        isButton?: boolean;
    }>();

    const emit = defineEmits<{
        click: [event: MouseEvent];
    }>();

    const onClick = (event: MouseEvent) => {
        emit('click', event);
    };
</script>

<template>
    <h2 class="h4 item-heading">
        <RouterLink v-if="to" :to="to" @click="onClick">
            {{ textMessage.Subject || $Resources.NoTitleLabel }}
        </RouterLink>
        <a v-else-if="!isButton" :href="href" @click="onClick">
            {{ textMessage.Subject || $Resources.NoTitleLabel }}
        </a>
        <a v-else role="button" @click="onClick">
            {{ textMessage.Subject || $Resources.NoTitleLabel }}
        </a>

        <small>{{ textMessage.Category.Name }}</small>

        <a
            v-if="textMessage.Event"
            class="mini-label mini-label-info m-xxs-l"
            rel="noopener"
            target="_blank"
            :href="'/Events/' + textMessage.Event.EventId"
            v-tooltip.top="textMessage.Event.Name">
            {{ $Resources.AssociatedEventLabel }}
        </a>
        <a
            v-if="textMessage.Journey"
            class="mini-label mini-label-info m-xxs-l"
            rel="noopener"
            target="_blank"
            :href="'/journeys/' + textMessage.Journey.JourneyId"
            v-tooltip.top="textMessage.Journey.Title">
            {{ $Resources.JourneysLabel }}
        </a>
        <button
            type="button"
            class="btn btn-subtle btn-sm"
            v-popover-info.top="{
                heading: $Resources.IssuePreviewButton,
                body: props.textMessage.Body,
                displayHtml: true,
            }">
            <span class="glyphicon glyphicon-eye-open" aria-hidden="true"></span>
            <span class="sr-only">{{ $Resources.IssuePreviewButton }}</span>
        </button>
    </h2>
</template>
